import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Row } from '@pella/sash-framework';

// Styles
import styles from './index.module.scss';

const RTACalendarTimeWrapper = ({ children, error, id }) => (
	<Row
		id={id}
		className={`${styles.rtaCalendarTime_Wrapper}${error ? ' ' + styles.rtaCalendar_Error : ''}`}
		justify='center'
	>
		{/* eslint-disable-next-line jsx-a11y/label-has-associated-control -- fix this */}
		<label className={styles.rtaCalendarTime_Label}>Date / Time</label>
		{children}
	</Row>
);

RTACalendarTimeWrapper.propTypes = {
	children: PropTypes.any,
	error: PropTypes.bool,
	id: PropTypes.string,
};

export default RTACalendarTimeWrapper;
